exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Legend {\n    padding: 0 16px 16px 32px;\n    margin: 0;\n}\n\n.Legend-description {\n    padding-bottom: 12px;\n}\n\n.Legend-period {\n    padding-bottom: 12px;\n}\n\n.Legend-filters {\n    padding-bottom: 12px;\n}\n\n.Legend-unit {\n    margin-left: 32px;\n    line-height: 24px;\n}\n\n.Legend-source {\n    padding-top: 16px;\n    font-size: 12px;\n}\n\n.Legend table {\n    border-collapse: collapse;\n    border-spacing: 0;\n}\n\n.Legend table tr {\n    height: 24px;\n}\n\n.Legend table th {\n    min-width: 24px;\n    height: 24px;\n    padding: 0;\n    vertical-align: middle;\n}\n\n.Legend table th span {\n    display: inline-block;\n    width: 100%;\n    height: 100%;\n    background-repeat: no-repeat;\n    background-position: center center;\n}\n\n.Legend table td {\n    padding-left: 10px;\n    white-space: nowrap;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/components/layers/legend/Legend.css
// module id = 1017
// module chunks = 0